module.exports = __webpack_public_path__ + "media/src/img/payment/kaspi_tenge_som_qr_modal-d0ad6d274c6253ca3e848043cf557278.png";